import { useState, useEffect } from "react"




const Invoiceupdatecell = ({ column: { id }, value: initialValue, updateLocalState }) => {

  const [value, setValue] = useState(initialValue);

  const onChange = (e) => {
    setValue(e.target.value);
  };
  const onBlur = () => {
    if (id === "newinvoicenumber") {
      if (value) {
        updateLocalState(value);
      }
    }
  }
  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);


  if (id === "newinvoicenumber") {

    return (

      <input type="text" onChange={onChange} onBlur={onBlur} style={{ outline: "none" }} ></input>
    )
  }
  return value
}



export const Invoiceupdatecolumn = {
  Cell: Invoiceupdatecell,
};